import { StyleSheet, Text, View } from 'react-native';

import { colors, fonts, fontSizes, spacing } from '@/constants/theme';

export function BreakdownRow({ label, value }: { label: string; value: string }) {
  return (
    <View style={styles.breakdownRow}>
      <Text style={styles.breakdownLabel}>{label}</Text>
      <Text style={styles.breakdownValue}>{value}</Text>
    </View>
  );
}

export const styles = StyleSheet.create({
  topBar: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    flex: 1,
    textAlign: 'center',
    fontFamily: fonts.bodyBold,
    fontSize: fontSizes.sm,
    color: colors.deepGreen,
  },
  titleSpacer: { width: 44 },
  heroCard: {
    padding: spacing.lg,
    gap: spacing.md,
    borderRadius: 24,
    overflow: 'hidden',
  },
  payoutLabel: {
    letterSpacing: 1.2,
  },
  breakdown: {
    backgroundColor: colors.glassFrostFill,
    borderRadius: 14,
    padding: 14,
    gap: 2,
  },
  breakdownRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 6,
  },
  breakdownLabel: {
    fontFamily: fonts.body,
    fontSize: fontSizes.xs,
    color: colors.textOnDarkStrong,
  },
  breakdownValue: {
    fontFamily: fonts.bodyBold,
    fontSize: fontSizes.xs,
    color: colors.frost,
    fontVariant: ['tabular-nums'],
  },
  infoBanner: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
    backgroundColor: colors.brightGreenSoft,
    borderRadius: 14,
    padding: 14,
  },
  infoBannerText: {
    flex: 1,
    fontFamily: fonts.body,
    fontSize: fontSizes.xs,
    color: colors.deepGreen,
    lineHeight: 18,
  },
  emailGuard: {
    padding: spacing.base,
    gap: spacing.md,
  },
  emailGuardContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.md,
  },
  emailGuardText: {
    flex: 1,
    fontFamily: fonts.body,
    fontSize: fontSizes.sm,
    color: colors.text,
  },
  errorText: {
    fontFamily: fonts.body,
    fontSize: fontSizes.xs,
    color: colors.danger,
    textAlign: 'center',
  },
  belowMinText: {
    fontFamily: fonts.body,
    fontSize: fontSizes.xs,
    color: colors.textMuted,
    textAlign: 'center',
  },
});
